import {
  Box,
  Tag,
  Text,
} from "@chakra-ui/react";
import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import ArrivalHeatmap from "../../ArrivalHeatmap";
import { formatNumber } from "../../../store/helpers";
import LineGraph from "../../LineGraph";
import ReportDataTable from "../../reports/ReportDataTable";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import { getArrivalRatesPerServiceRowsForScope } from "../../../store/arrivalRatesPerServiceExport";

export const renderArrivalRatesPerServiceCell = (serviceData, columnId) => {
  if (columnId === "serviceName") return serviceData.serviceName;
  if (columnId === "total") return formatNumber(serviceData.total);
  if (columnId === "percentage") return `${Number(serviceData.totalPct || 0).toFixed(2)}%`;
  if (columnId === "average") return formatNumber(serviceData.average);
  if (columnId === "min") return formatNumber(serviceData.min);
  if (columnId === "max") return formatNumber(serviceData.max);
  return null;
};

const BranchServicesTable = ({
  data,
  frequency,
  index,
  branchName,
  
  branchIndex,
  renderConfig,
  onRenderConfigChange,
}) => {
  const { serviceName, total, arrivalTimes, chart } = data;

  const heatMapTitle = serviceName + " Time of Day Chart";

  const title = `${branchIndex + 1}.${
    index + 1
  }. ${serviceName}`;
  
  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="arrivalRatesPerServiceBlock" mt="20px" mb="32px">
        <ReportDataTable
          columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={getArrivalRatesPerServiceRowsForScope({
            data: [data],
            branchName,
            scope: "Branch",
          }, renderConfig)}
          renderConfig={renderConfig}
          renderCell={renderArrivalRatesPerServiceCell}
          presortedRows={true}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <>
      <Box className="reportContainer" mt="20px">
        <h3>{title}</h3>
        <Tag.Root>
          <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
        </Tag.Root>
        {!total && (
          <Text fontSize="sm">No data available for this report</Text>
        )}

        {total ? (
          <Box mt="16px" mb="20px" h="350px">
            <LineGraph
              chart={chart}
              height={"300px"}
              title={`${serviceName} Arrival Rates, Day by Day Comparison`}
            />
            {frequency === ARRIVAL_RATES_FREQUENCIES.HOUR ? (
              <ArrivalHeatmap
                title={heatMapTitle}
                arrivalTimes={arrivalTimes}
                businessHoursSchedule={data.businessHoursSchedule}
              />
            ) : (
              <></>
            )}
          </Box>
        ) : null}
      </Box>
    </>
  );
};

export default BranchServicesTable;
